import { Routes, Route, Navigate } from "react-router-dom";
import { AuthGuard } from "@/components/AuthGuard.js";
import { LoginPage } from "@/pages/LoginPage.js";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage.js";
import { AdminsPage } from "@/pages/AdminsPage.js";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route
        path="/admins"
        element={
          <AuthGuard>
            <AdminsPage />
          </AuthGuard>
        }
      />
      <Route path="/" element={<Navigate to="/admins" replace />} />
      <Route path="*" element={<Navigate to="/admins" replace />} />
    </Routes>
  );
}
